import { Slide, TextAlignment } from '@/client/courses/types/courses.type';
import { RichTextEditor } from '@/ui/rich-text';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const SlideTitle = styled(RichTextEditor)`
  .ql-editor p {
    font-weight: 700;
    font-size: 30px;
  }

  min-width: 100px;
  margin: 0;
  padding: 0;
`;

type RichTextTitleProps = {
  currentEditingSlide: Slide;
  isEditingPopUpSlide: boolean;
  currentSlideData: Slide;
  updateSlide: (id: string, updates: Partial<Slide>) => void;
  isPurpleBackground?: boolean;
};

export const RichTextTitle: React.FC<RichTextTitleProps> = ({
  currentEditingSlide,
  isEditingPopUpSlide,
  currentSlideData,
  updateSlide,
  isPurpleBackground,
}) => {
  const { t } = useTranslation();

  return (
    <SlideTitle
      key={`title-editor-${isEditingPopUpSlide ? 'popup' : 'main'}`}
      value={currentEditingSlide?.headline || ''}
      theme="snow"
      className={`rich-text-editor rich-text-editor-v2 title ${
        currentSlideData.textAlignment === TextAlignment.CENTER
          ? 'text-center'
          : 'text-left'
      } ${isPurpleBackground ? 'rich-text-editor-summary' : ''}`}
      placeholder={
        isEditingPopUpSlide
          ? t('content.popup.slide.title')
          : t('content.slide.title')
      }
      onChange={(html, { text }) => {
        if (!currentEditingSlide?.id) return;

        updateSlide(currentEditingSlide.id, {
          headline: text.trim().length > 0 ? html : '',
        });
      }}
    />
  );
};
